var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Sorry Page doesnt exist")]),_c('h3',[_vm._v("The "+_vm._s(_vm.resource)+" you are looking for is not here")]),_c('router-link',{attrs:{"to":{name: 'DashBoard'}}},[_vm._v("Back to the home page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }